import { useWindowDimensions } from 'react-native'

const useColumns = (scale = 1): number => {
  const dimensions = useWindowDimensions()

  return Math.ceil(Math.max(2, Math.floor(dimensions.width / 256)) * scale)
}

export default useColumns
